import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '@environment';

export const accessGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  if (route.queryParams['context'] !== undefined || environment.sandbox) {
    return true;
  } else {
    router.navigate(['/connect']);
  }
  return false;
};
